import React from "react";
import { ChatbotConfigContext } from "./chatbot-config-context";

export function useChatbotConfig() {
  const context = React.useContext(ChatbotConfigContext);
  if (context === undefined) {
    throw new Error("useChatbotConfig must be used within a ChatbotConfigProvider");
  }
  return context;
}
